exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-link-archive-js": () => import("./../../../src/pages/link-archive.js" /* webpackChunkName: "component---src-pages-link-archive-js" */)
}

